import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_ABSENCE_EXCUSES } from '@/api/endpoints';
import { useStudyYearPeriods } from '@/pages/Overview/hooks/useStudyYearPeriods';
import type { StudyYearPeriod } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';
import { toApiDate } from '@/utils/date';

export enum AbsenceExcuseType {
  Unjustified = 'Unjustified',
  Sickness = 'Sickness',
  Other = 'Other',
}

export interface AbsenceExcuse {
  period: { from: string; to: string };
  type: AbsenceExcuseType;
  notes: string;
  timeCreated: string;
  authorUserId: number;
  authorName: string;
}

export const useAbsenceExcuses = (period: StudyYearPeriod) => {
  const { arePeriodsLoading } = useStudyYearPeriods();
  const from = toApiDate(period.from);
  const to = toApiDate(period.to);

  return useQuery<AbsenceExcuse[]>({
    queryKey: ['absence-excuses', from, to],
    enabled: !arePeriodsLoading,
    queryFn: () =>
      apiClient
        .get<AbsenceExcuse[]>(API_ABSENCE_EXCUSES, {
          params: {
            'datePeriodModel.from': from,
            'datePeriodModel.to': to,
          },
        })
        .then(unwrapAxiosResponse),
    placeholderData: keepPreviousData,
  });
};
